export {
  getOffersForProject,
  getIndexForOfferThatImpactsClosestTo100People,
  getOfferById,
  getPifProjects,
  getPeopleImpacted,
} from './PifService'
export type { Offer, Perk } from './PifService'
